/**
 * Shared split-auth brand copy for the pre-auth family (Login, Invite
 * Accept) — Golden A canonical pattern, `docs/agents/handoffs/
 * ERP-223-ui-reference-compliance.md`. Mirrors `AUTH_BRAND_COPY` /
 * `formatOrganizationDisplayLabel` in `apps/web/src/shared/
 * auth-pre-auth-chrome.tsx` by hand — apps/client cannot cross-import
 * apps/web, only `packages/design-system` is shared between the two apps.
 */
export const AUTH_BRAND_COPY = {
  brandLabel: 'ساختار سیستم',
  brandHeadline: 'سامانهٔ یکپارچهٔ مدیریت سازمان',
  brandTagline: 'فروش، انبار، تدارکات، مالی و پروژه — در یک فضای کاری یکپارچه.',
  brandFooter: 'ساختار · Pilot',
} as const;

/** Real product areas shown on the V2 auth brand panel — matches the sidebar's own module list, not marketing filler. */
export const AUTH_HIGHLIGHTS: readonly string[] = [
  'فروش و ارتباط با مشتری (CRM)',
  'انبار، تدارکات و زنجیرهٔ تأمین',
  'حسابداری، خزانه‌داری و مالیات',
];

/** Human-friendly organization label for the brand panel — never a raw `/t/` slug path. */
export function formatOrganizationDisplayLabel(slug: string): string | null {
  const trimmed = slug.trim();
  if (!trimmed) return null;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
